<template>
	<svg class="ls-icon ls-icon-user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<!-- Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE -->
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
			<circle cx="12" cy="7" r="4" />
		</g>
	</svg>
</template>
